export default "__VITE_ASSET__7f688a97__"